<template>
    <div id="app">
        <v-app id="inspire">
            <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                <v-card v-model="show" color="#FFFF99">
                    <v-card-title>
                        <v-icon large left>mdi-drawing</v-icon>
                        Gestión de Planos y Documentos
                    </v-card-title>
                    <v-card-text class="pt-2">
                        <v-row dense>
                            <v-col cols="12" md="4">
                                <v-select dense outlined :items="clientes" item-text="cliente" item-value="cliente"
                                    return-object label="Cliente" v-model="cliente" hide-details="auto"
                                    class="font-class-name" />
                            </v-col>
                            <v-col cols="12" md="7">
                                <v-select dense outlined :items="obras" item-text="obra" item-value="obra" label="Obra"
                                    return-object v-model="obra" hide-details="auto" class="font-class-name" />
                            </v-col>
                            <v-col cols="12" md="1">
                                <v-text-field dense outlined label="Nº" v-model="codigo" hide-details="auto"
                                    class="font-class-name" />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" md="4">
                                <v-select dense outlined :items="proyectistas" item-text="nombre" item-value="codigo"
                                    return-object label="Proyectistas" v-model="proyectista" hide-details="auto"
                                    class="font-class-name" />
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field dense outlined label="Texto contenido" v-model="descr" hide-details="auto"
                                    class="font-class-name" />
                            </v-col>
                            <v-col cols="12" md="2">
                                <v-checkbox dense label="con % de Avance?" v-model="avance" true-value="ON"
                                    false-value="" hide-details />
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" md="4">
                                <v-btn color="green" dark @click="ver()" max-width="200">
                                    Listado Documentos
                                </v-btn>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-btn color="blue" dark @click="cargar()" depressed max-width="200">
                                    Cargar Documentos
                                </v-btn>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-btn color="orange" dark @click="editar()" depressed max-width="200">
                                    Editar Documentos
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-form>
            <Ver :visible="showVer" :numcliente="cliente.numcliente" :numobra="obra.numobra" :descr="descr"
                :avance="avance" :proyectista="proyectista.codigo" :cliente="cliente.nomcliente" :obra="obra.nomobra"
                :codigo="codigo" @close="showVer = false">
            </Ver>
            <Cargar :visible="showCargar" :numcliente="cliente.numcliente" :numobra="obra.numobra" :descr="descr"
                :avance="avance" :proyectista="proyectista.codigo" :cliente="cliente.nomcliente" :obra="obra.nomobra"
                :codigo="codigo" @close="showCargar = false">
            </Cargar>
            <Editar :visible="showEditar" :numcliente="cliente.numcliente" :numobra="obra.numobra" :descr="descr"
                :avance="avance" :proyectista="proyectista.codigo" :cliente="cliente.nomcliente" :obra="obra.nomobra"
                :codigo="codigo" @close="showEditar = false">
            </Editar>
        </v-app>
    </div>
</template>

<style scoped>
.font-class-name {
    font-size: 12px;
}
</style>

<script>
import moment from "moment";
import axios from "../../../axios-auth";
import Ver from "../Documentos/Listadodoc.vue";
import Cargar from "../Documentos/Cargardoc.vue";
import Editar from "../Documentos/Editardoc.vue";
export default {
    components: { Ver, Cargar, Editar },
    data() {
        return {
            lazy: false,
            valid: false,
            deshabilitar: false,
            codigo: "",
            cliente: "",
            obra: "",
            proyectista: "",
            avance: "",
            descr: "",
            proyectistas: [],
            clientes: [],
            obras: [],
            listado: [],
            showVer: false,
            showCargar: false,
            showEditar: false,

        };
    },
    watch: {
        cliente(newVal) {
            this.numcliente = this.cliente.numcliente;
            this.listadoobras();
        },
        obra(newVal) {
            if (this.obra.nct == "0") { this.codigo = "XXX-YY-T-ZZ"; }
            else {
                this.codigo = "XXX-YYY-T-ZZZ";
            }
        },
    },
    computed: {
        show: {
            get() {
                //this.mostrar = true;
                this.elaboro = this.$store.state.nombre.toString().trim();
                this.listadoclientes();
                this.listadoproyectistas();
            },
            set(value) {
                if (!value) {
                    this.vaciarListado();
                    this.$emit("close");
                }
            },
        },
    },
    methods: {
        vaciarModels() {
            const initialState = this.$options.data.call(this);

            Object.keys(initialState).forEach((key) => {
                this[key] = initialState[key];
            });
        },
        listadoclientes() {
            let self = this;
            axios
                .get("/Ingenieria/Listadoclientes?", {
                    params: {
                        filtrocliente: '',
                    },
                })
                .then((response) => {
                    self.clientes = response.data;
                })
                .catch((error) => {
                    self.clientes = [];
                    console.log(error);
                });
        },
        listadoobras() {
            //this.obras = [];
            console.log("ENTRO a obras")
            let self = this;
            axios
                .get("/Ingenieria/Listadoobras?", {
                    params: {
                        filtroobra: '',
                        filtrocliente: self.numcliente,
                    },
                })
                .then((response) => {
                    self.obras = response.data;
                })
                .catch((error) => {
                    self.obras = [];
                    console.log(error);
                });
        },
        listadoproyectistas() {
            let self = this;
            axios
                .get("/Ingenieria/Listadoproyectistas?")
                .then((response) => {
                    self.proyectistas = response.data;
                })
                .catch((error) => {
                    self.proyectistas = [];
                    console.log(error);
                });
        },

        ver(item) {
            // this.editedIndex = this.listado.indexOf(item);
            // this.editedItem = Object.assign({}, item);
            this.showVer = true;
        },
        cargar(item) {
            // this.editedIndex = this.listado.indexOf(item);
            // this.editedItem = Object.assign({}, item);
            this.showCargar = true;
        },
        editar(item) {
            this.showEditar = true;
        }
    },
};
</script>
